import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://loftpress.shop";
const DEFAULT_OG = `${SITE_URL}/og-default.png`;

/**
 * Reusable per-page <head> block. Emits:
 *   - <title>, description, canonical, robots
 *   - Open Graph + Twitter card
 *   - hreflang alternates for /en and /tr where relevant (link-only hint)
 *   - Optional JSON-LD structured data (single object or array).
 */
export default function Head({
  title,
  description,
  path = "/",
  lang = "en",
  ogImage = DEFAULT_OG,
  ogType = "website",
  robots = "index, follow",
  jsonLd = null,
}) {
  const canonical = SITE_URL + path;
  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet htmlAttributes={{ lang }} prioritizeSeoTags>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />
      {/* Open Graph */}
      <meta property="og:site_name" content="LoftPress" />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : "en_GB"} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={ogImage} />
      {jsonLdArray.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}

export const SITE = SITE_URL;
